import React from 'react';
import ListingImageGallery from './ListingImageGallery/ListingImageGallery';
import { Button } from '../../components';

import css from './ListingPage.module.css';

const SectionGallery = props => {
  const { listing, variantPrefix, currentUser, onToggleFavorites } = props;

  // Add defensive check for images
  if (!listing?.images || listing.images.length === 0) {
    return (
      <section className={css.productGallery} data-testid="carousel">
        <div className={css.galleryContainer}>
          <div className={css.loadingPlaceholder}>Loading images...</div>
        </div>
      </section>
    );
  }

  const images = listing.images;

  // Use the variant prefix from configuration to ensure consistent variants
  const variantPrefixToUse = variantPrefix || 'listing-card';

  const imageVariants = [
    `${variantPrefixToUse}`,
    `${variantPrefixToUse}-2x`,
    'scaled-small',
    'scaled-medium',
    'scaled-large',
    'scaled-xlarge',
  ];
  const thumbnailVariants = [
    variantPrefixToUse,
    `${variantPrefixToUse}-2x`,
    `${variantPrefixToUse}-4x`,
  ];

  // Check if listing is favorited
  const favorites =
    currentUser?.attributes.profile.privateData?.favorites || [];
  const isFavorite = favorites.includes(listing.id.uuid);

  // Simple function to toggle favorites
  const toggleFavorites = e => {
    // Prevent default browser behavior and stop event propagation
    e.preventDefault();
    e.stopPropagation();

    // Invoke the callback passed from parent
    if (onToggleFavorites) {
      onToggleFavorites(isFavorite);
    }
  };

  const favoriteButton = (
    <Button
      type="button"
      rootClassName={
        isFavorite ? css.favoriteButtonOverlayActive : css.favoriteButtonOverlay
      }
      onClick={toggleFavorites}
      title={isFavorite ? 'Remove from favorites' : 'Add to favorites'}
    >
      <svg
        width="20"
        height="20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
      >
        <path
          d="M12 20.84l-1.45-1.32C5.4 14.86 2 11.78 2 8 2 4.92 4.42 2.5 7.5 2.5c1.74 0 3.41 0.81 4.5 2.09C13.09 2.31 14.76 2.5 16.5 2.5 19.58 2.5 22 4.92 22 8c0 3.78-3.4 6.86-8.55 11.54L12 20.84z"
          fill={isFavorite ? 'white' : 'transparent'}
          stroke={isFavorite ? 'white' : '#1D1D1D'}
          strokeWidth="1.5"
        />
      </svg>
    </Button>
  );

  return (
    <section className={css.productGallery} data-testid="carousel">
      <div className={css.galleryContainer}>
        {images && images.length > 0 ? (
          <ListingImageGallery
            images={images.filter(
              img => img && img.attributes && img.attributes.variants
            )}
            imageVariants={imageVariants}
            thumbnailVariants={thumbnailVariants}
            key={listing.id.uuid}
          />
        ) : (
          <div className={css.loadingPlaceholder}>Loading images...</div>
        )}
        {onToggleFavorites && currentUser && (
          <div
            className={css.favoriteOverlay}
            onClick={e => e.stopPropagation()} // Prevent event propagation
          >
            {favoriteButton}
          </div>
        )}
      </div>
    </section>
  );
};

export default SectionGallery;
